module.exports = __webpack_public_path__ + "static/media/Stellar Max King Headboard - 180 cm_Grey.90a860ca.png";